export default __webpack_public_path__ + "static/media/benefit_15@2x.c62f64f1.png";